module.exports = __webpack_public_path__ + "img/orange-header-in.abe4d2fd.png";